import React, { useState } from "react";
import { List, DateField } from "@refinedev/mui";
import { IResourceComponentsProps } from "@refinedev/core";
import { IGrantVestmentRequest } from "interfaces/grant-vestment-request";
import { EvaluateGrantVestmentRequestModal } from "components/modal/evaluate-grant-vestment-request";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { moneyFormat } from "utils/money-format";
import { InfiniteList } from "components/list/infinity-list";
export const PendingGrantVestmentRequestList: React.FC<
  IResourceComponentsProps
> = () => {
  const [open, setOpen] = useState(false);
  const [decision, setDecision] = useState<{
    grantvestmentRequest: IGrantVestmentRequest | undefined;
    value: "PENDING" | "APPROVED" | "REJECTED";
  }>({ grantvestmentRequest: undefined, value: "PENDING" });

  return (
    <>
      <List title=" Pending GrantVestment Request List">
        <InfiniteList<IGrantVestmentRequest>
          endpoint="grant-vestment-requests"
          limit={10}
          isTable={true}
          columns={[
            {
              field: "grantVestmentRequestId",
              header: "ID",
            },
            {
              field: "grantVestment",
              header: "Grant vestment title",
              width: 200,
              renderCell: function render({ grantVestment }) {
                return grantVestment.name;
              },
            },
            {
              field: "fund",
              header: "Fund Name",
              width: 200,
              renderCell: function render({ fund }) {
                return fund.fundAccountName;
              },
            },
            {
              field: "user",
              header: "Advisor",
              renderCell: function render({ user }) {
                return `${user.firstName} ${user.lastName}`;
              },
            },
            {
              field: "requestedAmount",
              header: "Requested Amount",
              renderCell: function render({ requestedAmount }) {
                return <>${moneyFormat(requestedAmount)}</>;
              },
            },
            {
              field: "status",
              header: "Status",
            },
            {
              field: "emailToNotify",
              header: "Email To Notify",
              width: 200,
            },
            {
              field: "transactionType",
              header: "Type",
            },
            {
              field: "createdAt",
              header: "Created Date",
              renderCell: function render({ createdAt }) {
                return <DateField value={createdAt} />;
              },
            },
            {
              header: "Actions",
              renderCell: function render(row) {
                return (
                  <>
                    {" "}
                    <IconButton
                      onClick={() => {
                        setDecision({
                          grantvestmentRequest: row,
                          value: "APPROVED",
                        });
                        setOpen(true);
                      }}
                    >
                      <CheckIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setDecision({
                          grantvestmentRequest: row,
                          value: "REJECTED",
                        });
                        setOpen(true);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </>
                );
              },
            },
          ]}
          additionalFilters={[
            {
              field: "filter[status]",
              operator: "eq",
              value: "PENDING",
            },
            {
              field: "filter[transfer]",
              operator: "eq",
              value: "false",
            },
          ]}
          tableProps={{
            stickyHeader: true,
            headerBgColor: "grey.200",
            responsive: true,
          }}
          emptyMessage={`No GrantVestment request found!`}
        />
      </List>
      <EvaluateGrantVestmentRequestModal
        visible={open}
        close={setOpen}
        data={decision}
      />
    </>
  );
};
